module.exports = __webpack_public_path__ + "static/media/AU-NewSouthWales.a33bde3c.png";